<template>
  <form v-on:submit.prevent="onSubmit">
    <div class="modal-header">
      <h4 class="modal-title">Add Owner Type</h4>
    </div>

    <div class="modal-body">
      <div class="form-group">
        <label for="ownerTypeName">Name <span class="red-dot ml-3"></span></label>
        <input id="ownerTypeName" name="ownerTypeName" type="text" class="form-control" :class="{ 'is-invalid': errors.has('ownerTypeName') }"
          autocomplete="off" placeholder="Name" v-model="ownerType.name" v-validate="'required'" data-vv-as="Name" />
        <div class="invalid-feedback">The Name field is required.</div>
      </div>

      <div class="form-group">
        <label for="ownerTypeSortOrder">Sort Order <span class="red-dot ml-3"></span></label>
        <input id="ownerTypeSortOrder" name="ownerTypeSortOrder" type="text" class="form-control" :class="{ 'is-invalid': errors.has('ownerTypeSortOrder') }"
          autocomplete="off" placeholder="Sort Order" v-model="ownerType.sortOrder" v-validate="'required'" data-vv-as="Sort Order" />
        <div class="invalid-feedback">The Sort Order field is required.</div>
      </div>
    </div>

    <div class="modal-footer">
      <button type="submit" class="btn btn-success">Save</button>
      <button type="button" class="btn btn-secondary" @click="closeModal">Close</button>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Toast from "@/utils/toast";

export default {
  name: 'contact-type',
  data: function () {
    return {
      isEdit: false,
      ownerType: {}
    }
  },
  computed: {
    ...mapGetters(["getOwnerType"])
  },
  mounted: function() {
    this.ownerType = { ...this.getOwnerType };
    this.isEdit = !!this.ownerType.id;
    this.$validator.reset();
  },
  methods: {
    async onSubmit() {
      var isFormValid = await this.$validator.validate();

      if (!isFormValid) {
        return;
      }

      this.saveOwnerType({ data: this.ownerType, isEdit: this.isEdit })
        .then(() => {
          Toast.success(this, "Successfully saved!");
          this.$bvModal.hide("bv-modal-owner-type");
          this.closeModal();
        })
        .catch(() => {
          Toast.danger(this, "Oops! There was an error.");
          this.closeModal();
        });
    },
    closeModal() {
      this.$bvModal.hide("bv-modal-owner-type");
    },
    ...mapActions(["saveOwnerType"])
  }
}
</script>
